import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { formatApiErrorDetail } from '../../lib/api';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9d663873-ece1-460a-abc5-f98dcd211b2a/artifacts/qilm7q3e_A087EB80-08A6-4F5B-B90E-AA189E10D04B.png";

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      navigate('/admin');
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/">
            <img src={LOGO_URL} alt="Grand Priory Crest" className="w-24 h-24 mx-auto mb-4" />
          </Link>
          <h1 className="font-heading text-3xl text-[#1A1614]">Back Office Portal</h1>
          <p className="text-sm text-[#8A847A] mt-2">Grand Priory of the Caribbean</p>
        </div>

        {/* Login Form */}
        <div className="bg-white border border-[#D8D2C4] p-8" data-testid="login-form-container">
          <h2 className="font-heading text-xl text-[#1A1614] mb-6 text-center">Sign In</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="block text-sm font-medium text-[#1A1614] mb-2">Email Address</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="rounded-none border-[#D8D2C4] focus:border-[#C5A059]"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1A1614] mb-2">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="rounded-none border-[#D8D2C4] focus:border-[#C5A059]"
                data-testid="login-password-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-[#7B1818] text-white hover:bg-[#5C1212] rounded-none"
              data-testid="login-submit-button"
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-sm text-[#7B1818] hover:underline">
              ← Return to Public Site
            </Link>
          </div>
        </div>

        <p className="text-center text-xs text-[#8A847A] mt-4">
          This portal is for authorized personnel only.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
